import { FunctionComponent } from 'react';
import { ModalDialog } from '@gaiads/telia-react-component-library';
import { useSelector } from 'react-redux';

import { RootState } from '../../store/reducers';

const GlobalModal: FunctionComponent = () => {
  const modal = useSelector((state: RootState) => state.notifications.modal);
  return (
    <ModalDialog
      isOpen={modal.open}
      title={modal.title}
      acceptButtonText={modal.acceptButtonText}
      closeButtonText={modal.closeButtonText}
      onAcceptClick={modal.onAccept}
      onCloseClick={modal.onClose}
      destructive={modal.destructive}
      className={modal.classes}
    >
      {modal.children}
    </ModalDialog>
  );
};

export default GlobalModal;
